export const selectMask = (fieldValue, masks) => {
  const digits = fieldValue.replace(/\D/g, '');
  return (
    masks.find(mask => digits.length <= mask.replace(/\D/g, '').length) || masks[masks.length - 1]
  );
};
